import React from 'react';
import ModalBody from '../UI/Modal/ModalBody/ModalBody';

const sections = [
  {
    title: 'Tarjouspyynnöt',
    description:
      'Täällä näet kaikki saapuneet tarjouspyynnöt. Voit suodattaa ja avata yksittäisiä pyyntöjä. Saatavilla myös tekoälyavusteinen vastausluonnos talonomistajalle, jonka pohjaa voit muokata yrityksesi uniikeilla tiedoilla Yritykseni-sivulla.',
  },
  {
    title: 'Myyntiputki',
    description:
      'Myyntiputkessa seuraat tarjousten etenemistä. Siirrä tarjouksia vaiheesta toiseen. Toiminto ei lähetä tarjousta asiakkaalle automaattisesti, joten voit kokeilla huoletta.',
  },
  {
    title: 'Tarjoushistoria',
    description:
      'Täältä löydät kaikki aiemmat tarjouksesi ja niiden tilat.',
  },
  {
    title: 'Yrityksesi asetukset',
    description:
      'Pidä organisaatiosi tiedot ajan tasalla — yhteystiedot, laskutustiedot ja asetukset. Täällä voit myös muokata tekoälyavusteisen tarjousluonnoksen pohjatietoja yrityksestäsi. Voit myös lisätä ja muokata yrityksesi käyttäjäprofiileita.',
  },
];

const ServiceGuideModal: React.FC = () => {
  return (
    <ModalBody>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
        {sections.map((section) => (
          <div
            key={section.title}
            style={{
              backgroundColor: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: '8px',
              padding: '1.25rem',
            }}
          >
            <h3
              style={{
                margin: '0 0 0.5rem 0',
                fontSize: '1rem',
                color: '#0f172a',
                fontWeight: 600,
              }}
            >
              {section.title}
            </h3>
            <p
              style={{
                margin: 0,
                fontSize: '0.9rem',
                color: '#475569',
                lineHeight: '1.6',
              }}
            >
              {section.description}
            </p>
          </div>
        ))}
      </div>
    </ModalBody>
  );
};

export default ServiceGuideModal;
